interface JoinDateAndTimeStringsToISOParams {
  date?: string,
  time?: string,
  options?: {
    defaultToEndOfDay?: boolean,
  },
}

// date format: 'YYYY-MM-DD'
// time format: 'HH:mm'
const joinDateAndTimeStringsToISO = (params: JoinDateAndTimeStringsToISOParams) => {
  const { date, time, options } = params
  const { defaultToEndOfDay } = options || {}

  if (!date) return undefined
  if (date && !time){
    if (defaultToEndOfDay){
      return `${date}T23:59:59`
    }
    return `${date}T00:00:00`
  }

  return `${date}T${time}`
}

export default joinDateAndTimeStringsToISO
